import { useState } from "react";
import { Link } from "@/components/common/Link";
import { MapPin, Phone, Mail, Send } from "lucide-react";
export default function MapContactSection() {
  const [mapLoaded, setMapLoaded] = useState(false);
  return <section className="relative w-full bg-muted flex items-stretch min-h-[450px]">
      <div className="relative w-full min-h-[450px] lg:min-h-[600px]">
        {}
        <div className="absolute z-20 top-6 left-6 right-6 md:left-12 md:top-12 md:right-auto w-auto md:w-[320px] bg-card p-6 rounded-lg shadow-lg border border-border">
          <h3 className="text-xl font-bold text-foreground mb-4 font-sans">
            A-Z Umzüge
          </h3>

          <ul className="flex flex-col gap-4 list-none p-0 m-0">
            <li className="flex items-start gap-3 text-sm text-muted-foreground">
              <MapPin className="w-5 h-5 text-primary shrink-0" />
              <span className="leading-relaxed">Schillerstr. 14, 32257 Bünde</span>
            </li>

            <li className="flex items-center gap-3 text-sm">
              <Phone className="w-5 h-5 text-primary shrink-0" />
              <Link to="tel:01726274452" className="text-muted-foreground hover:text-primary hover:underline transition-colors duration-150">
                Mobil: 0172 62 74 452
              </Link>
            </li>

            <li className="flex items-center gap-3 text-sm">
              <Mail className="w-5 h-5 text-primary shrink-0" />
              <Link to="mailto:web.az@umzuege-az.de" className="text-muted-foreground hover:text-primary hover:underline transition-colors duration-150">
                web.az@umzuege-az.de
              </Link>
            </li>
          </ul>

          <div className="mt-6">
            <Link to="https://maps.google.com/?q=Schillerstr.+14,+32257+Bünde" newTab className="inline-flex items-center justify-center w-full md:w-auto gap-2 px-6 py-2.5 bg-primary text-primary-foreground font-medium rounded-lg hover:opacity-90 transition-all duration-200 shadow-md">
              <Send className="w-4 h-4" />
              Route planen
            </Link>
          </div>
        </div>

        {}
        <div className="absolute inset-0 w-full h-full bg-muted flex items-center justify-center overflow-hidden">
          {!mapLoaded && <div className="flex flex-col items-center justify-center gap-4 p-8 text-center z-10">
              <div className="bg-background/80 p-4 rounded-lg shadow-sm">
                <MapPin className="w-12 h-12 text-primary mb-2 mx-auto" />
                <p className="text-sm text-muted-foreground max-w-[250px] mb-4">
                  Bitte akzeptieren Sie Cookies, um die interaktive Karte zu laden.
                </p>
                <button onClick={() => setMapLoaded(true)} className="px-8 py-2 bg-primary text-primary-foreground font-medium rounded-lg hover:opacity-90 transition-all cursor-pointer shadow-sm">
                  Karte laden
                </button>
              </div>
            </div>}
          
          {mapLoaded && <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2432.444444444444!2d8.583333!3d52.194444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47ba177777777777%3A0x7777777777777777!2sSchillerstra%C3%9Fe%2014%2C%2032257%20B%C3%BCnde!5e0!3m2!1sde!2sde!4v1710000000000" className="w-full h-full border-0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="A-Z Umzüge Standort" />}
        </div>
      </div>
    </section>;
}